module.exports = __webpack_public_path__ + "static/img/14h.9c4dccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14h.jpg
// module id = lMal
// module chunks = 0